// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { saigon as _saigon } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the saigon chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 2021
 * Chain Name: Saigon Testnet
 * Default Block Explorer: https://saigon-app.roninchain.com
 * Default RPC URL: https://saigon-testnet.roninchain.com/rpc
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { saigon } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: saigon,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const saigon = createCommon({
	..._saigon,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
